import React, { createContext, useReducer, useContext } from "react"

const defaultState = {
  toggle: true,
}

const HomeStateContext = createContext(defaultState)
const HomeDispatchContext = createContext()

const homeReducer = (state, action) => {
  switch (action.type) {
    case "TOGGLE_LIGHT":
      return {
        ...state,
        toggle: action.payload,
      }
    default:
      return state
  }
}

export const HomeProvider = ({ children }) => {
  const [state, dispatch] = useReducer(homeReducer, {
    toggle: true,
  })

  return (
    <HomeStateContext.Provider value={state}>
      <HomeDispatchContext.Provider value={dispatch}>
        {children}
      </HomeDispatchContext.Provider>
    </HomeStateContext.Provider>
  )
}

export const useHomeStateContext = () => useContext(HomeStateContext)
export const useHomeDispatchContext = () => useContext(HomeDispatchContext)
